import { urlUtility } from "@repo/utilities/url.utility.ts";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGetServiceProps } from "@api/types/globalService.types";
import URLS from "@api/constants/urls";
import { useState } from "react";

const useBankBranchesService = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
}: IGetServiceProps) => {
  //States
  const [searchQuery, setSearchQuery] = useState("");
  //Hooks
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  //variables
  const created_between = urlQueries["created_between"] || "";
  const ifscCode = urlQueries?.["ifsc_code"];
  // Services
  const getAllBankBranchesService = useQuery({
    queryKey: [
      ...CACHE_KEYS.BANK_BRANCHES,
      debouncedQuery,
      ifscCode,
      created_between,
      page,
      per_page,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.BANK_BRANCHES,
        searchParams: {
          "filter[branch_name]": debouncedQuery,
          "filter[created_between]": created_between,
          ...(!!ifscCode &&
            ifscCode.length >= 4 && { "filter[ifsc_code]": ifscCode }),
          page: page,
          per_page: per_page,
        },
      }),
    enabled: enableQuery && (ifscCode?.length === 4 || ifscCode === undefined),
  });

  return {
    states: { searchQuery, setSearchQuery },
    service: { getAllBankBranchesService },
  };
};

export { useBankBranchesService };
